import { render } from "./GroupProfile.vue?vue&type=template&id=61c66d48&scoped=true"
import script from "./GroupProfile.vue?vue&type=script&lang=js"
export * from "./GroupProfile.vue?vue&type=script&lang=js"

import "./GroupProfile.vue?vue&type=style&index=0&id=61c66d48&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c66d48"]])

export default __exports__